import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import qs from 'qs';

function submitProContactForm(_x, _x2) {
  return _submitProContactForm.apply(this, arguments);
}

function _submitProContactForm() {
  _submitProContactForm = _asyncToGenerator(function* (context, formData) {
    var locale = context.state.i18n.currentLocale;
    var url = "".concat(locale.market, "/").concat(locale.language, "/professionnels/contact-form");
    return context.$axios({
      method: 'POST',
      url,
      data: qs.stringify(formData),
      headers: {
        'content-type': 'application/x-www-form-urlencoded'
      }
    });
  });
  return _submitProContactForm.apply(this, arguments);
}

export default submitProContactForm;